<template>
  <div class="rootContainer">
    <searchBar
      class="searchBar"
      searchType="5"
      @search="onSearch"
      @pageCloseed="onpageCloseed"
    ></searchBar>

    <div id="top-bar-container">
      <filterMenu
        title="分类"
        displayName="name"
        v-model="category"
        :filtersContent="categorys"
        :openShowMoreBtn="true"
        @selectChanged="filterChanged"
      ></filterMenu>

      <div class="fixed-filter-container">
        <div>
          <filterMenu
            title="排序"
            displayName="name"
            v-model="sort"
            :filtersContent="sortFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="价格"
            displayName="name"
            v-model="price"
            :filtersContent="resourceLevelOptions"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="授权"
            displayName="name"
            v-model="commerical"
            :filtersContent="commericalFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <styleMenu
          class="style-layout"
          v-model="currentStyle"
          :menuList="StyleArrayMsg"
          @selectChange="onStyleChange"
        ></styleMenu>
      </div>
    </div>
    <div
      class="content-container"
      ref="contentcontainer"
      @scroll="handleScroll"
    >
      <ul class="content-list">
        <li
          v-for="(item, index) in contentList"
          :key="index"
          @click="selectMusic(item, $event)"
        >
          <div class="music-item">
            <div
              style="
                width: 300px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
              "
            >
              <span class="music-item-title">{{ item.title }}</span>
              <div v-show="item.companyIcon" class="company-logo">
                <img :src="$handleAssetsUrl(item.companyIcon)" alt />
                <div class="company-arrow-box">
                  <span>{{ item.company }}</span>
                </div>
              </div>
              <div
                v-show="item.isCommerical"
                class="music-item-commerical-logo"
              ></div>
            </div>

            <div
              class="music-item-play-btn"
              :class="[
                item === musicer.currentMusic && musicer.isPlay
                  ? 'music-item-play-btn-pause'
                  : 'music-item-play-btn-play',
              ]"
              @click="musicSelectAndPlay(item)"
            ></div>
            <div
              class="favorites-btn"
              @click="favoriteItem(item)"
              :class="[
                item && item.favorites ? 'already-favorites' : 'favorites',
              ]"
            ></div>
            <!-- <span
              v-if="item.payType == 4"
              class="music-item-price music-item-price-payType4"
              >会员免费</span
            >
            <span
              v-if="item.payType == 0"
              class="music-item-price music-item-price-payType0"
              >免费</span
            >
            <span
              v-if="item.payType == 1"
              class="music-item-price music-item-price-payType1"
              >{{ item.tt ? "已购买" : "￥" + item.price }}</span
            > -->
            <div v-if="item.payType == 1 && !item.tt" class="music-item-price">
              <span class="price">￥{{ item.price }}</span>
            </div>
            <div v-if="item.payType == 1 && item.tt" class="music-item-price">
              <img class="bought" />
            </div>
            <div v-if="item.payType == 4" class="music-item-price">
              <img :class="[getBadgeClassName(item.payType, IsOldUser ? 'commonVip' : 'enterpriseS')]" />
            </div>
            <div v-if="item.payType == 6" class="music-item-price">
              <img :class="getBadgeClassName(item.payType, 'companyVip')" />
            </div>
          </div>
        </li>
      </ul>
    </div>

    <isEmptyResult
      v-if="loadingStatus == 2 && contentList.length == 0"
    ></isEmptyResult>

    <div class="music-operate-bar-container" v-if="musicer.currentMusic">
      <div class="music-operate-bar">
        <div
          class="play-btn"
          :class="[musicer.isPlay ? 'play-btn-pause' : 'play-btn-play']"
          @click.stop="musicPlay"
        ></div>
        <div style="height: 100%; margin-right: 40px">
          <div style="display: flex; justify-content: space-between">
            <span class="music-title">{{ musicer.currentMusic.title }}</span>
            <span class="music-time-msg">{{
              musicTimeConverter(musicer.currentTime) +
              ' / ' +
              musicTimeConverter(musicer.currentMusic.duration)
            }}</span>
          </div>
          <audio
            ref="audio"
            controls="controls"
            volume="20"
            style="display: none"
            :src="$handleAssetsUrl(musicer.currentMusic.url)"
            @loadedmetadata="getAudioLength"
            @timeupdate="audioTimeUpdate"
            @play="handPlay"
            @pause="handPause"
          ></audio>
          <div class="music-play-slider">
            <el-slider
              :show-tooltip="false"
              v-model="musicer.currentTime"
              :max="musicer.duration"
              @change="changeAudioTime"
            ></el-slider>
          </div>
        </div>

        <div
          class="favorites-btn"
          @click.stop="favoriteItem(musicer.currentMusic)"
          :class="[
            musicer.currentMusic && musicer.currentMusic.favorites
              ? 'already-favorites'
              : 'favorites',
          ]"
        ></div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <span v-if="musicer.currentMusic.payType === 1" class="price-msg">{{
          '￥' + musicer.currentMusic.price + '元'
        }}</span>
        <span class="add-btn" @click="addToCanvas">立即添加</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import searchBar from "../searchBar";
import styleMenu from "../dropDownMenu";
import filterMenu from "../filterMenu";
import isEmptyResult from "../isEmptyResult";
import baseContent from "./baseContent.vue";
import addSound from '@/components/rightnav/slide/addSound.js';
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [baseContent, addSound, vipBadge],
  name: "musicContent",
  data () {
    return {
      type: 5,

      //条件筛选
      priceFlags: [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        // { name: "付费", value: "&payType=1" },
        { name: "会员专属", value: "&payType=4" },
        { name: "企业会员专属", value: "&payType=6" },
      ],
      //当前选中音乐
      musicer: {
        currentMusic: undefined,
        isPlay: false,
        playProcessor: "0%",
        currentTime: 0, //当前播放时间
        duration: 0, //标记时间戳
      },
    };
  },
  props: {},
  components: {
    searchBar,
    styleMenu,
    filterMenu,
    isEmptyResult,
  },
  methods: {
    onpageCloseed: function () {
      if (this.musicer.isPlay) {
        this.$refs.audio.pause();
      }
    },

    getContentList: function () {
      this.loadingStatus = 1;
      // let url =
      //   "/api/common/material?type=5&fPage=24&sOfPage=24&pIndex=" +
      //   this.pageIndex +
      //   "&draftId=" +
      //   window.location.hash.slice(2);
       let url =
        "/api/common/material?type=5&fPage=24&sOfPage=24&pIndex=" +
        this.pageIndex;
      if (this.category && this.category.id) {
        const pair = [0, 0];
        const cate = this.category;
        if (cate.isStory === 0) {
          pair[0] = cate.id;
        }
        if (cate.isStory === 1) {
          pair[1] = cate.id
        }
        const urlValue = pair.join(',');
        url += "&category=" + urlValue;
      }
      // if (this.currentStyle) {
      //   url += "&style=" + this.currentStyle.id;
      // }
      if (this.sort) {
        url += this.sort.value;
      }
      if (this.price) {
        url += this.price.value;
      }
      if (this.commerical) {
        url += this.commerical.value;
      }
      if (
        typeof this.keyWord != "undefined" &&
        this.keyWord != null &&
        this.keyWord != ""
      ) {
        url += "&keyword=" + this.keyWord;
      }
      this.setTrackingData(url);
      this.$http
        .get(url)
        .then((res) => {
          if (this.keyWord) {
            let order_methods = {
              "": "推荐",
              "&orderBy=2": "最新",
            };
            let choose_prices = {
              "": "全部",
              "&payType=0": "免费",
              "&payType=4": "会员专属",
              "&payType=6": "企业会员专属",
              "&payType=1": "付费",
            };
            sensors.track("classifySearchResult", {
              search_source: "编辑器素材弹窗",
              keyword: this.keyWord,
              has_result: !!(res.data.data && res.data.data.length),
              material_type: "声音",
              search_type: "素材搜索",
              search_result_num: res.data.data.length,
              keyword_type: this.trackingData.keyword_type || "手动输入",
              order_method: this.sort ? order_methods[this.sort.value] : "推荐",
              choose_price: this.price
                ? choose_prices[this.price.value]
                : "全部",
            });
          }
          if (!this.contentList) {
            this.contentList = res.data.data;
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              this.contentList.push(res.data.data[i]);
            }
          }

          if (res.data.total <= this.contentList.length) {
            this.loadingStatus = 2;
          } else {
            this.loadingStatus = 0;
          }
        })
        .catch((res) => {
          //console.log("获取数据失败");
          this.loadingStatus = 0;
        });
    },

    selectMusic: function (item, ev) {
      let flag = ev.target.classList.contains('music-item-play-btn') ||
        ev.target.classList.contains('favorites-btn');
      if (flag) {
        ev.stopPropagation();
        return;
      }
      this.musicer = {
        currentMusic: item,
        isPlay: false,
        playProcessor: "0%",
        currentTime: 0, //当前播放时间
        duration: 0, //标记时间戳
      };
      // this.setMusic(item);
    },
    musicSelectAndPlay: function (item) {
      //1.是否是同一个
      if (this.musicer.currentMusic != item) {
        if (this.musicer.isPlay) {
          this.$refs.audio.pause();
        }
        this.musicer = {
          currentMusic: item,
          isPlay: false,
          playProcessor: "0%",
          currentTime: 0, //当前播放时间
          duration: 0, //标记时间戳
        };
      } else {
        this.musicPlay();
      }

      //this.musicPlay();
    },
    musicPlay: function () {
      if (!this.musicer.isPlay) {
        this.$refs.audio.play();
      } else {
        this.$refs.audio.pause();
      }
    },
    audioTimeUpdate: function () {
      let time = this.$refs.audio.currentTime;
      if (time - this.musicer.currentTime > 1) {
        this.musicer.currentTime = time;
      }
    },
    getAudioLength: function () {
      this.musicer.duration = parseInt(this.$refs.audio.duration);
      // this.musicPlay();
    },
    musicTimeConverter (duration) {
      let totalSecond = parseInt(duration); // 秒
      if (totalSecond <= 0) {
        return "00:00";
      }
      let second = 0;
      let minute = 0; // 分

      if (totalSecond > 60) {
        minute = parseInt(totalSecond / 60);
        second = parseInt(totalSecond % 60);
      } else {
        second = totalSecond;
      }
      let result = "";
      if (minute < 10) {
        result = "0" + minute;
      } else {
        result = minute;
      }

      if (second < 10) {
        result += ":0" + second;
      } else {
        result += ":" + second;
      }

      return result;
    },
    handPlay: function () {
      this.musicer.isPlay = true;
    },
    handPause: function () {
      this.musicer.isPlay = false;
      if (this.$refs.audio.ended) {
        this.musicer.currentTime = 0;
      }
    },
    changeAudioTime: function (val) {
      if (this.$refs.audio) {
        this.$refs.audio.currentTime = val;
      }
    },
    favoriteItem: function (item) {
      let postBody = {
        type: 5,
        id: item.id,
      };
      if (item.favorites) {
        postBody.isCancel = 1;
      }
      item.sprite = item;
      this.trackCollectContent({ ...item, collect_content: "声音" }, postBody);
      this.$http.post("/api/user/favorites", postBody).then((res) => {
        if (res.data.code == 200) {
          this.showLikesToast(postBody.isCancel ? 'unlikes' : 'likes');
          //请求的返回值中没有带收藏信息
          //所以这里做一个本地的伪处理
          if (item.favorites) {
            item.favorites = null;
            this.$bus.emit("favorites.toggle", item, false); //通知右侧列表
          } else {
            item.favorites = true;
            this.$bus.emit("favorites.toggle", item, true);
          }
        }
      });
    },
    addToCanvas: function () {
      let music = this.musicer.currentMusic;
      this.$bus.emit('beforeAddToCanvas', {data: music, type: 'sound'});
      this.trackSearchResultClick(music);
      // this.TOOL.setSound(
      //   {
      //     // 添加全局bgm
      //     resourceId: music.id, // 资源id 用于查询资源的信息，下同
      //     title: music.title,
      //     fileType: music.fileType,
      //     url: this.$handleAssetsUrl(music.url), // 资源路径
      //     isLoop: true, // 是否循环
      //     volume: 50, // 音量0-100
      //     subtitle: null, // 字幕（预留字段）
      //     endTime: 0,
      //     startTime: 0,
      //   },
      //   true
      // );
      this.setMusic(music);
      let mArr = this.$store.getters['addSoundtrack/getMusicArr'];
      this.$bus.emit('checkMaterial.music', mArr);
      this.onpageCloseed();
      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    handleScroll (e) {
      if (this.loadingStatus != 0) {
        return;
      }
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.contentcontainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.pageIndex++;
        this.getContentList();
      }
    },
  },
  watch: {},
  computed: {
    ...mapGetters(["StyleArrayMsg", "TOOL", "WorksProjectId", 'IsOldUser']),
    ...mapGetters({
      musicArr: 'addSoundtrack/getMusicArr',
      dubbingArr: 'addSoundtrack/getDubbingArr'
    }),
    getProcessor () {
      return (this.musicer.currentTime / this.musicer.duration) * 100 + "%";
    },
  },
  created () {
    this.sort = this.sortFlags[0];
    this.price = this.priceFlags[0];
    this.commerical = this.commericalFlags[0];
  },
  mounted () { },
};
</script>

<style scoped lang="scss">
.rootContainer {
  position: relative;
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#top-bar-container {
  background-color: #fff;
  min-height: 50px;
  margin: 8px 40px 20px 40px;
  padding: 0;
  flex-shrink: 0;
}

.fixed-filter-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 20px;
  /* margin-top: 10px; */
  padding: 0px;
}
.fixed-filter-container .fixedFilter {
  margin-left: 39px;
}

.fixed-filter-container /deep/ .list-container {
  margin-left: 10px;
}

.fixed-filter-container /deep/ .list li {
  padding: 0 10px;
}

.style-layout {
  margin-left: 39px;
  margin-top: 12px;
}

.content-container {
  width: 100%;
  overflow-y: auto;
  flex-grow: 1;
}
.content-list {
  padding: 22px 0px 0px 39px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  /* overflow-y: auto; */
  /* height: 494px; */
  width: 100%;
  /* flex-grow: 1; */
}

.content-list li {
  width: 493px;
  height: 60px;
  background-color: #fafafd;
  border-radius: 4px;
  border: solid 1px #dbdff0;
  margin-right: 1px;
  margin-bottom: 2px;
  box-sizing: border-box;
}

.content-list li:hover {
  background-color: #dbdff0;
}

.music-item {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.music-item-title {
  width: 160px;
  text-align: left;
  margin-left: 21px;
  margin-right: 12px;
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.music-item-commerical-logo {
  width: 20px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/commerical.svg);
  background-repeat: no-repeat;
  background-size: cover;
}
.company-logo {
  position: relative;
  width: 20px;
  height: 19px;
  margin-right: 2px;
}

.company-logo img {
  position: absolute;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.company-logo:hover .company-arrow-box {
  display: block;
}

.company-arrow-box {
  display: none;
  float: left;
  color: transparent;
  border-radius: 3px;
  width: auto;
  height: 24px;
  background-color: #000000;
  margin-left: 50%;
  transform: translate(-50%, -120%);
}
.company-arrow-box span {
  width: 105%;
  font-size: 12px;
  color: #f8dbb2;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 5px;
  text-align: left;
}
.company-arrow-box:after {
  content: '';
  width: 0;
  height: 0;
  border-width: 5px;
  border-style: solid;
  border-top-color: #000000;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
}

.music-item-play-btn {
  width: 16px;
  height: 18px;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 20px;
}

.music-item-play-btn-play {
  background-image: url(../../../../../static/svg/template-material-lib/music/music-select-play.svg);
}

.music-item-play-btn-pause {
  background-image: url(../../../../../static/svg/template-material-lib/music/music-select-pause.svg);
}

.music-item-price {
  //width: 130px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
  padding-right: 13px;
}

.commonVip {
  width: 36px;
  height: 16px;
  content: url('../../../../../static/svg/payTypeSubscript/vip36x16.svg');
}
.enterpriseS {
  width: 50px;
  height: 16px;
  // content: url('../../../../../static/svg/payTypeSubscript/enterpriseS.png');
  content: url('../../../../../static/svg/payTypeSubscript/enterpriseSVIP.svg');
}
.companyVip {
  width: 50px;
  height: 16px;
  content: url('../../../../../static/svg/payTypeSubscript/companyVip50x16.svg');
}

.bought {
  width: 50px;
  height: 16px;
  content: url('../../../../../static/svg/payTypeSubscript/bought50x16.svg');
}

.price {
  font-size: 16px;
  color: #484262;
  font-weight: bold;
}
.pro {
  width: 30px;
  height: 18px;
  content: url(../../../../assets/pro.png);
}
.proPlus {
  width: 32px;
  height: 18px;
  content: url(../../../../assets/proPlus.png);
}
// .discount {
//   font-size: 12px;
//   color: #484262;
//   text-decoration: line-through;
//   margin-right: 9px;
// }

// .music-item-price-discount {
//   font-size: 12px;
//   color: #474261;
//   text-decoration: line-through;
// }

.music-operate-bar-container {
  /* position: absolute; */
  height: 56px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  /* bottom: 0px; */
  background-color: #fff;
}

.play-btn {
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin-right: 20px;
}

.play-btn-play {
  background-image: url(../../../../../static/svg/template-material-lib/music/music-play.svg);
}

.play-btn-pause {
  background-image: url(../../../../../static/svg/template-material-lib/music/music-pause.svg);
}

.music-operate-bar {
  height: 34px;
  margin-right: 40px;
  margin-left: 39px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.favorites {
  background-image: url(../../../../../static/svg/template-material-lib/music/favorite-music.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

.already-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/music/already-favorite-music.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

.favorites-btn {
  width: 18px;
  height: 18px;
}

.discount-msg {
  text-decoration: line-through;
  font-size: 14px;
  font-weight: normal;
}

.price-msg {
  font-weight: bold;
  font-size: 14px;
  color: #ff3a3f;
  align-self: center;
  margin-right: 26px;
}

.add-btn {
  width: 120px;
  height: 56px;
  background-color: #5778fb;
  border-radius: 0px 0px 8px 0px;
  padding: 16px 10px;
  font-size: 16px;
  color: #ffffff;
}

.music-title {
  width: 160px;
  text-align: left;
  font-size: 14px;
  color: #474261;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.music-time-msg {
  width: 50%;
  text-align: right;
}

.music-play-slider {
  /* position: relative; */
  width: 360px;
  margin-top: -8px;
}
.music-play-slider >>> .el-slider__runway {
  width: 100%;
  height: 2px;
  /* margin: 16px 0; */
  background-color: #dbdff0;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}
.music-play-slider >>> .el-slider__bar {
  height: 2px;
  background-color: #5778fb;
  position: absolute;
}
.music-play-slider >>> .el-slider__button {
  width: 12px;
  height: 12px;
  background-color: #5778fb;
  border-radius: 50%;
  transition: 0.2s;
  -webkit-user-select: none;
  user-select: none;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/musicContent.vue